import React from "react";
import ControlToggle from "./ControlToggle";
import ControlBiolyt from "./ControlBiolyt";
import ControlChicken from "./ControlChicken";
import ControlComfoair350 from "./ControlComfoair350";
import ControlLedStripe from "./ControlLedStripe";
import ControlMieleDevice from "./ControlMieleDevice";
import ControlBoschDevice from "./ControlBoschDevice";
import ControlUnknown from "./ControlUnknown";
import ControlPhotoVoltaic from "./ControlPhotoVoltaic";
import ControlClimate from "./ControlClimate";
import ControlSound from "./ControlSound";
import { IControl } from "./types";
import { Grid } from "@mui/material";

interface IControlsListProps {
  controls: IControl[];
}

const ControlsList = (props: IControlsListProps) => {
  const { controls } = props;
  return (
    <Grid
      container
      padding={{ xs: 1, sm: 1 }}
      spacing={{ xs: 1, sm: 1 }}
      data-cy="controls"
    >
      {controls.map((control, index) => {
        if (control.control_type === "TOGGLE") {
          return <ControlToggle key={index} control={control} />;
        } else if (control.control_type === "BIOLYT") {
          return <ControlBiolyt key={index} control={control} />;
        } else if (control.control_type === "CHICKEN") {
          return <ControlChicken key={index} control={control} />;
        } else if (control.control_type === "COMFOAIR350") {
          return <ControlComfoair350 key={index} control={control} />;
        } else if (control.control_type === "LED_STRIPE") {
          return <ControlLedStripe key={index} control={control} />;
        } else if (control.control_type === "MIELE_DEVICE") {
          return <ControlMieleDevice key={index} control={control} />;
        } else if (control.control_type === "BOSCH_DEVICE") {
          return <ControlBoschDevice key={index} control={control} />;
        } else if (control.control_type === "PHOTO_VOLTAIC") {
          return <ControlPhotoVoltaic key={index} control={control} />;
        } else if (control.control_type === "CLIMATE") {
          return <ControlClimate key={index} control={control} />;
        } else if (control.control_type === "SOUND") {
          return <ControlSound key={index} control={control} />;
        } else {
          return <ControlUnknown key={index} />;
        }
      })}
    </Grid>
  );
};

export default ControlsList;
